import { render, staticRenderFns } from "./ListOrganization.vue?vue&type=template&id=530ffda6&scoped=true"
import script from "./ListOrganization.vue?vue&type=script&lang=js"
export * from "./ListOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ffda6",
  null
  
)

export default component.exports